import { render } from "./FlashMessage.vue?vue&type=template&id=6028b676"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__